import { commonTranslationKeys, FieldControllerProps, FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { prefixFieldName } from './common.utils';

type TownFieldProps = Pick<FormContextValues, 'register'> &
   Pick<FieldControllerProps<'town', string | null>, 'name' | 'required'> &
   ClassNameProp & {
      readonly prefix?: string;
   };

export const TownField = (props: TownFieldProps): JSX.Element => {
   const { name, prefix, required, register } = props;
   const fieldName = prefixFieldName(name, prefix);
   return (
      <TextInput
         controller={register(fieldName, {
            maxLength: 50,
            required: required,
         })}
         label={commonTranslationKeys.addressData.town}
         testId={fieldName}
      />
   );
};
